import { SetCellBySnFrom1CQuery } from "../set-warehouse-and-celll-by-sn/set-cell-by-sn-from-1c-query";

export class SetServiceCellBySnFrom1CQuery extends SetCellBySnFrom1CQuery {
}